import React from "react";
import "./styles/EditorialBlock.css";

/**
 * Alternating image/text row. Currently only Profil uses this (the
 * "Pädagogisches Profil" page), but it's a distinct enough pattern —
 * and specific enough about its own layout math (grid-template-columns
 * flip, text-only full width) — to live in the shared library rather
 * than the page.
 *
 * `align` flips which side the image sits on; blocks with no image
 * span the full width instead of sitting in a half-width column, since
 * alternation only means something when there's an image to swap with.
 *
 * <EditorialBlock
 *   icon={<IconByName name={block.icon} />}
 *   kicker={block.kicker}
 *   title={block.title}
 *   text={block.text}
 *   image={block.image}
 *   align={i % 2 === 0 ? "left" : "right"}
 * />
 */
export default function EditorialBlock({ icon, kicker, title, text, image, align = "left" }) {
  const isRight = align === "right";
  const hasImage = Boolean(image);

  return (
    <article
      className={`rs-editorial ${hasImage && isRight ? "is-right" : ""} ${
        hasImage ? "" : "is-text-only"
      }`}
    >
      <div className="rs-editorial__text">
        <div className="rs-editorial__kicker">
          {icon && (
            <span className="rs-editorial__icon" aria-hidden="true">
              {icon}
            </span>
          )}
          <span className="rs-kicker">{kicker}</span>
        </div>

        <h3>{title}</h3>
        <p>{text}</p>
      </div>

      {hasImage && (
        <div className="rs-editorial__media">
          <figure className="rs-editorial__frame">
            <img src={image.url} alt={image.alt || title} loading="lazy" />
          </figure>
        </div>
      )}
    </article>
  );
}